import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { OnboardingPageService } from '../../onboarding-page/onboarding-page.service';
import { ToastMessage } from '../../toast-message/toast-message.service';

@Component({
  selector: 'app-fleet-onboarding-start',
  template: require('./fleet-onboarding-start.component.html'),
  providers: [OnboardingPageService]
})
export class FleetOnboardingStartComponent {

  public overHeadPanelTitle = 'Fleet Onboarding - Start';

  public mobile: string;
  public errorMessage: string = '';
  public errorDescription: string = '';
  public loading = false;

  mobileFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern('^[6-9][0-9]{9}$')
  ]);

  constructor(
    private router: Router,
    private onboardingService: OnboardingPageService,
    private toastMessage: ToastMessage
  ) {}

  isFormValid() {
    return this.mobileFormControl.valid;
  }

  async start() {
    this.errorMessage = '';
    this.errorDescription = '';
    if (!this.isFormValid()) { return; }
    this.loading = true;
    try {
      // Call our proxy GET /api/fleet with source and mobile
      let fleetData: any = null;
      try {
        const fleetResp: any = await this.onboardingService.getFleetByMobile(this.mobile).toPromise();
        const list = fleetResp && fleetResp.data ? fleetResp.data : [];
        if (Array.isArray(list) && list.length > 0) {
          fleetData = list[0];
        }
      } catch (_e) {
        // ignore; proceed to create
      }

      if (fleetData && fleetData._id) {
        const status: string = (fleetData.status ? String(fleetData.status) : '').toLowerCase();
        if (status === 'active') {
          // If fleet is already active, just show error toast
          this.toastMessage.openSnackBarError(
            `Fleet is already active with this number: ${this.mobile}`, 
            2000
          );
          return;
        } else {
          // Not active → Navigate with prefill using available data only
          const emails = Array.isArray(fleetData.email) ? fleetData.email.join(', ') : (fleetData.email || '');
          const cityId = Array.isArray(fleetData.cities) && fleetData.cities.length > 0 ? fleetData.cities[0] : '';
          // Map backend type (e.g., thirdParty) to UI option value (third_party)
          const prefillType = fleetData.type === 'thirdParty' ? 'third_party' : fleetData.type;
          this.router.navigate(['/fleetOnboardingDetails'], {
            queryParams: {
              fleetId: fleetData._id,
              _id: fleetData._id,
              createdBy: fleetData.createdBy,
              type: prefillType,
              createdAt: fleetData.createdAt,
              lastModifiedOn: fleetData.lastModifiedOn,
              status: fleetData.status,
              remarks: fleetData.remarks,
              lastModifiedBy: fleetData.lastModifiedBy,
              modeId: fleetData.modeId,
              mode: fleetData.mode,
              dob: fleetData.dob,
              mobile: this.mobile,
              // fields to auto-populate
              name: fleetData.name,
              gstNumber: fleetData.gstNumber,
              emails: emails,
              cityId: cityId
            }
          });
          return;
        }
      }

      // Fallback: create flow (existing behavior)
      const response: any = await this.onboardingService.createFleet(this.mobile).toPromise();
      const data = response && response.data ? response.data : null;
      if (data && data._id) {
        this.router.navigate(['/fleetOnboardingDetails'], {
          queryParams: {
            fleetId: data._id,
            _id: data._id,
            createdBy: data.createdBy,
            type: data.type,
            createdAt: data.createdAt,
            lastModifiedOn: data.lastModifiedOn,
            status: data.status,
            remarks: data.remarks,
            lastModifiedBy: data.lastModifiedBy,
            modeId: data.modeId,
            dob: data.dob,
            mobile: this.mobile
          }
        });
      } else {
        this.toastMessage.openSnackBarError((response && response.info && response.info.message) || 'Unexpected response', 2000);
      }
    } catch (err) {
      const httpErr: any = err || {};
      let backend: any = (httpErr.error !== undefined && httpErr.error !== null) ? httpErr.error : httpErr;
      if (typeof backend === 'string') {
        try { backend = JSON.parse(backend); } catch { /* keep as string */ }
      }
      const msg = (backend && (backend.message || (backend.info && backend.info.message))) || httpErr.message ||  'Failed to start onboarding';
      const desc = (backend && (backend.description || (backend.data && backend.data.description))) || '';
      const combined = desc ? (String(msg) + ': ' + String(desc)) : String(msg);
      this.toastMessage.openSnackBarError(combined, 2000);
    } finally {
      this.loading = false;
    }
  }

  goBack() {
    this.router.navigate(['/onboardFleet']);
  }
} 